/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { FxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultFacebookInstantGamesOptions } from './FxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultFacebookInstantGamesOptions';
import {
    instanceOfFxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultFacebookInstantGamesOptions,
    FxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultFacebookInstantGamesOptionsFromJSON,
    FxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultFacebookInstantGamesOptionsFromJSONTyped,
    FxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultFacebookInstantGamesOptionsToJSON,
} from './FxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultFacebookInstantGamesOptions';

/**
 * @type FxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultFacebookInstantGames
 * 
 * @export
 */
export type FxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultFacebookInstantGames = FxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultFacebookInstantGamesOptions;

export function FxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultFacebookInstantGamesFromJSON(json: any): FxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultFacebookInstantGames {
    return FxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultFacebookInstantGamesFromJSONTyped(json, false);
}

export function FxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultFacebookInstantGamesFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultFacebookInstantGames {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultFacebookInstantGamesOptions(json)) {
        return FxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultFacebookInstantGamesOptionsFromJSONTyped(json, true);
    }

    return {} as any;
}

export function FxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultFacebookInstantGamesToJSON(json: any): any {
    return FxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultFacebookInstantGamesToJSONTyped(json, false);
}

export function FxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultFacebookInstantGamesToJSONTyped(value?: FxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultFacebookInstantGames | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    if (instanceOfFxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultFacebookInstantGamesOptions(value)) {
        return FxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultFacebookInstantGamesOptionsToJSON(value as FxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultFacebookInstantGamesOptions);
    }

    return {};
}

